import { MockDrgAdapter } from "./adapters/MockDrgAdapter.js";
// import { RoDrgApiAdapter } from "./adapters/RoDrgApiAdapter.js";
import '../../styles/theme.css';

const USE_MOCK = true; // switch to false when you have a vendor

export function createDrgAdapter() {
  if (USE_MOCK) return new MockDrgAdapter();

  // Example when ready:
  // return new RoDrgApiAdapter(
  //   import.meta.env.VITE_RO_DRG_BASE_URL,
  //   async () => import.meta.env.VITE_RO_DRG_TOKEN
  // );
}
export async function groupCase({ principal, secondary }) {
  // Temporary test logic until you hook up a real DRG service
  const chest = /^(I2|R07)/i.test(principal);
  return {
    drg: chest ? "F62Z" : "B80Z",
    vr: chest ? 1.35 : 0.92
  };
}